import React from 'react';
import { Table } from 'react-bootstrap';

const ProposalTable = ({ proposals }) => {
    /* bool propTypeProposal;
        mapping (address => bool) approvalTracker;
        uint voteCount;
        address proposer;
        string category;
        uint spend;
        address receiver;
    */
    function singleProposal(proposal) {
        // console.log(proposal[0]);
        if (proposal[0] != 0){
            let propType = "Spend";
            if (proposal[1] == 1) {
                propType = "Make Admin";
            }
            if (proposal[1] == 3) {
                propType = "Whitelist Perms";
            }
            if (proposal[1] == 4) {
                propType = "Group Action";
            }
            return (
                <tr>
                    <td>{proposal[0]}</td>
                    <td>{propType}</td>
                    <td>{proposal[6]}</td>
                    <td>{proposal[4]}</td>
                    <td>{proposal[3]} TRX</td>
                    <td>{proposal[8]}</td>
                </tr>
            );
        }
        

    };
    // console.log(proposals);
    return (
        <Table bordered hover variant="light">
            <thead>
                <tr>
                    <th>Proposal ID</th>
                    <th>Type of Proposal</th>
                    <th>Proposing Address</th>
                    <th>Category</th>
                    <th>Spend Amount</th>
                    <th>Receiving Address</th>
                </tr>
            </thead>
            <tbody>
                {proposals?.map(singleProposal)}
            </tbody>
        </Table>
    )
    
    
}

export default ProposalTable;
